import {formatBigNum} from 'hiya-common/src/utils'
import _debounce from 'lodash/debounce'
import {useCallback, useEffect} from 'react'
import {PaymentPage} from 'hiya-common/src/constant'
import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'
// 用于将摩天轮旋转起来的数组
const mapChangeFinger = [1, 2, 3, 4, 5, 6, 7, 0]
// 对应高亮的真实index，用于换算目标到当前坐标需要跳转的渲染距离
const mapBoxIndex = [0, 1, 2, 3, 4, 5, 6, 7]
const animationTime = {
  win: 3000,
  bigPrize: 2680,
}

// 划算并补足目前位置到目标位置的index距离，如果距离开奖结果的位置<3
// 就加一部分，例如目前位置到目标位置为0就去让结果渲染动画补一圈
const getAfterDrawMapBox = ({
  nextIndex,
  targetIndex,
}: {
  nextIndex: number
  targetIndex: number
}) => {
  const distance = targetIndex - nextIndex
  if (distance === 0) {
    // 直接转一圈
    return (
      mapBoxIndex
        // 截取末尾
        .slice(nextIndex)
        // 拼接头部
        .concat(mapBoxIndex.slice(0, targetIndex + 1))
    )
  }
  if (distance > 0) {
    if (distance >= 3) {
      return mapBoxIndex.slice(nextIndex, targetIndex + 1)
    }
    return mapBoxIndex
      .slice(nextIndex)
      .concat(mapBoxIndex.slice(0, targetIndex + 1))
  }
  if (distance < 0) {
    const normalArr = mapBoxIndex
      .slice(nextIndex)
      .concat(mapBoxIndex.slice(0, targetIndex + 1))
    if (normalArr.length < 3) {
      return mapBoxIndex
        .slice(nextIndex)
        .concat(mapBoxIndex, mapBoxIndex.slice(0, targetIndex + 1))
    }
  }
  // distance < 0 的情况 也就是target在当前指示的后面 并且距离大于3
  return mapBoxIndex
    .slice(nextIndex)
    .concat(mapBoxIndex.slice(0, targetIndex + 1))
}

const closeCurWindow = () => {
  window.HiyaJSBridge.callHandler('closeWindow')
}
export enum subPageName {
  排行榜 = 'RankModal',
  记录页 = 'RecordModal',
  规则页 = 'RuleModal',
  获胜记录 = 'WinModal',
  jackpot规则页 = 'JackpotModal',
  超级奖池排行榜 = 'SuperRankModal',
  超级奖池规则页 = 'SuperRuleModal',
}

export enum GreedyProZIndex {
  结果弹窗 = 9991,
  结果历史弹窗 = 9990,
  引导页 = 9999,
}

const getBigNum = ({
  num,
  max,
  reserveNum,
}: {
  num: number
  max?: number
  reserveNum?: number
}) => {
  if (max && num < max) {
    return num
  }
  return formatBigNum(Number(num) || 0, reserveNum || 1)
}

export function useGoRecharge() {
  return useCallback(
    _debounce(() => {
      window.HiyaJSBridge.callHandler('openScheme', {
        url: `hiya://openWindow?fullscreen=1&other_info=${encodeURIComponent(
          JSON.stringify({
            from: 'h5_GreedyHiya',
          })
        )}&external=0&need_user_info=1&url=${PaymentPage}`,
      })
    }, 500),
    []
  )
}

const getRoundNo = (roundNo) => {
  return roundNo.toString().slice(8).replace(/^0+/, '')
}
const sleep = (s) => {
  return new Promise((res) => {
    setTimeout(() => {
      res(null)
    }, s)
  })
}

const getGameId = (path = '') => {
  const arr = (path || window.location.pathname).split('/')
  return Number(arr[arr.length - 1])
}

enum GreedyProSoundEnum {
  box = `${HostMaps.auto.img01}/download/file?obj=mefile/64/b5/e9a0-add6-11ee-b0ae-00163e0442bb` as any,
  lotteryBox = `${HostMaps.auto.img01}/download/file?obj=mefile/6b/49/0106-add6-11ee-ae81-00163e04069f` as any,
  countDownTime = `${HostMaps.auto.img01}/download/file?obj=mefile/71/5a/0939-add6-11ee-ae81-00163e04069f` as any,
  winPop = `${HostMaps.auto.img01}/download/file?obj=mefile/76/a7/4332-add6-11ee-b0ae-00163e0442bb` as any,
  bet = `${HostMaps.auto.img01}/download/file?obj=mefile/7b/80/b470-add6-11ee-b0ae-00163e0442bb` as any,
  shake = `${HostMaps.auto.img01}/download/file?obj=mefile/7f/d8/5a68-add6-11ee-ae81-00163e04069f` as any,
  rotateWheel = `${HostMaps.auto.img01}/download/file?obj=mefile/85/02/5284-add6-11ee-b0ae-00163e0442bb` as any,
}
enum GreedyProSoundTypeEnum {
  '宝箱' = 'box',
  '抽奖机开奖' = 'lotteryBox',
  '倒计时' = 'countDownTime',
  '胜利弹窗' = 'winPop',
  '下注' = 'bet',
  '摇奖机' = 'shake',
  '转盘单音' = 'rotateWheel',
}

const greedyProPlaySound = (type: GreedyProSoundTypeEnum) => {
  const {playing} = window.store.getState().GameGreedyPro
  if (!playing) {
    return
  }
  // window.HiyaJSBridge.callHandler('stopSound')
  window.HiyaJSBridge.callHandler('playSound', {
    url: GreedyProSoundEnum[type],
  })
}
const greedyProStopSound = () => {
  window.HiyaJSBridge.callHandler('stopSound')
}

const randomNumber = (n, m) => {
  const random = Math.floor(Math.random() * (m - n + 1) + n)
  return random
}

const getRecallImgSrc = (key) => {
  const rewarsPng = require.context('./images/recall/', false)
  const src = rewarsPng.keys().find((v) => {
    return v.indexOf(key) !== -1
  })
  return src && rewarsPng(src)
}

const getGreedyProFreePlayLocalData = (): {
  step: number
  proHasPopedMinBetTip24: boolean
  proHasPopedMinBetTip1: boolean
} => {
  const local = JSON.parse(localStorage.getItem('greedyProFreePlay') || '{}')
  return {
    step: 0,
    proHasPopedMinBetTip24: false,
    proHasPopedMinBetTip1: false,
    ...local,
  }
}

const greedyProFreePlayLocalSet = (data = {}) => {
  const obj = Object.assign(getGreedyProFreePlayLocalData(), data)
  localStorage.setItem('greedyProFreePlay', JSON.stringify(obj))
}

export {
  animationTime,
  closeCurWindow,
  getAfterDrawMapBox,
  getBigNum,
  getGameId,
  getGreedyProFreePlayLocalData,
  getRecallImgSrc,
  getRoundNo,
  greedyProFreePlayLocalSet,
  greedyProPlaySound,
  GreedyProSoundEnum,
  GreedyProSoundTypeEnum,
  greedyProStopSound,
  mapBoxIndex,
  mapChangeFinger,
  randomNumber,
  sleep,
}
